export default __webpack_public_path__ + "static/media/exceptionalCS.44aa81c8.png";